import { useCallback, useEffect, useState } from 'react'
import { setGlobalMissionContext } from '@/api'

const STORAGE_KEY = 'spectreiq.selectedMissionId'

export function useMissionContext() {
  const [selectedMissionId, setSelectedMissionIdState] = useState<string | null>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY)
    } catch {
      return null
    }
  })

  const setSelectedMissionId = useCallback((missionId: string | null) => {
    setSelectedMissionIdState(missionId)
    try {
      if (missionId) {
        localStorage.setItem(STORAGE_KEY, missionId)
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }
    } catch {
      // ignore storage errors (private mode, etc.)
    }
  }, [])

  useEffect(() => {
    setGlobalMissionContext(selectedMissionId)
  }, [selectedMissionId])

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key !== STORAGE_KEY) return
      setSelectedMissionIdState(e.newValue)
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  return { selectedMissionId, setSelectedMissionId }
}

